import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../../app/modules/auth/core/Auth';
import SafeImage from '../../../../app/modules/widgets/SafeImage';
import { type ContactType } from '@/app/models/Contact';
import { ThemeModeSwitcher } from '@/_metronic/partials';
import { USER_MENU_BY_USER_TYPE } from './core/_consts';

const itemClass = 'ms-1 ms-md-4';
const userAvatarClass = 'symbol-35px';

const LightNavbar = () => {
  const { currentUser } = useAuth();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);

  // Close the user menu when clicking outside its container (trigger + menu).
  useEffect(() => {
    if (!isUserMenuOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);

  const UserMenu = USER_MENU_BY_USER_TYPE[currentUser?.type?.value as ContactType];

  return (
    <div className="app-navbar flex-shrink-0">
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div ref={userMenuRef} className="position-relative">
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            onClick={() => setIsUserMenuOpen((prev) => !prev)}
          >
            <SafeImage
              alt="Imagem do usuário"
              className="mb-4 align-self-center rounded cursor-pointer"
              fallbackName={currentUser?.name}
              height={35}
              src={currentUser?.profile_picture_url}
              width={35}
            />
          </div>
          {UserMenu ? <UserMenu isOpen={isUserMenuOpen} onClose={() => setIsUserMenuOpen(false)} /> : null}
        </div>
      </div>
    </div>
  );
};

export { LightNavbar };
